import React, { useEffect, useState } from "react";
import Accordion from "react-bootstrap/Accordion";
import "./MotorSkillsTracking.css";
import { baby_images } from "assets/icons";
import useFullPageLoader from "common/UseFullPageLoader";
import { MotorSkillTrackingListApi } from "services/motorSkillTracking";
import moment from "moment";
import { formatTimeInDays } from "utils/common";
import { dateFormatWithTime } from "utils/dateFormat";

const MotorSkillsTracking = ({ _child }) => {
  const [loader, onShow, onHide] = useFullPageLoader();
  const [trackingList, setTrackingList] = useState([]);
  const [selectedTracking, setSelectedTracking] = useState({});
  const [meta, setMeta] = useState({});

  const fetchData = async () => {
    try {
      onShow();
      const { data, status } = await MotorSkillTrackingListApi({
        childId: _child,
      });
      if (status === 200) {
        setTrackingList(data?.data);
        setMeta(data?.meta);
      }
    } catch (e) {
      console.log(e);
    } finally {
      onHide();
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      <div className="motorskillTracking_parent">
        {loader}
        <div className="motorskilltracking_wraper">

          <div className="row">
            <div className=" col-sm-12 col-md-6 col-lg-6">
              <div className="motorskilltracking_lft">
                <Accordion className="outer_accordian">
                  {trackingList.map((tracking, i) => {
                    return (
                      <Accordion.Item eventKey={i} key={tracking.id}>
                        <Accordion.Header>{tracking.name}</Accordion.Header>

                        <Accordion.Body>
                          <Accordion className="inner_accordian">
                            {tracking?.skills?.map((motor_skill) => {
                              return (
                                <Accordion.Item
                                  eventKey={motor_skill.id}
                                  key={motor_skill.id}
                                >
                                  <Accordion.Header
                                    onClick={() => {
                                      if (motor_skill?.motorSkillTracking) {
                                        setSelectedTracking(motor_skill);
                                      } else {
                                        setSelectedTracking({});
                                      }
                                    }}
                                  >
                                    <div className="accordian_parent">
                                      <div className="accordian_child">
                                        <ul>
                                          <li>{motor_skill.name}</li>
                                          <li>{`${tracking.startWeek}-${tracking.endWeek} Months`}</li>
                                          {motor_skill?.motorSkillTracking ? (
                                            <li>
                                              {/* {formatTimeInDays(
                                                moment(meta?.child?.dateOfBirth)
                                                  .add(
                                                    motor_skill
                                                      ?.motorSkillTracking
                                                      ?.completedWeek,
                                                    "weeks"
                                                  )
                                                  .diff(
                                                    moment(
                                                      meta?.child?.dateOfBirth
                                                    ),
                                                    "seconds"
                                                  )
                                              )} */}
                                               { console.log({sss:meta?.child?.dateOfBirth})}
                                              {
                                                
                                                moment(meta?.child?.dateOfBirth)
                                                  .add(
                                                    motor_skill
                                                      ?.motorSkillTracking
                                                      ?.completedWeek,
                                                    "weeks"
                                                  ).toLocaleString()
                                              }
                                            </li>
                                          ) : (
                                            <li>---</li>
                                          )}
                                        </ul>
                                      </div>
                                    </div>
                                  </Accordion.Header>
                                </Accordion.Item>
                              );
                            })}
                          </Accordion>
                        </Accordion.Body>
                      </Accordion.Item>
                    );
                  })}
                </Accordion>
              </div>
            </div>

            {selectedTracking?._id ? (
              <div className=" col-sm-12 col-md-6 col-lg-6">
                <div className="motorskilltracking_rgt">
                  <div className="motorskilltracking_card">
                    <div className="header-title">
                      {selectedTracking?.name || ""}
                    </div>
                    <div className="date-time">
                      Date & Time
                      <br />
                      {dateFormatWithTime(
                        selectedTracking?.motorSkillTracking?.createdAt
                      )}
                    </div>
                    <div className="motorskilltracking-note">
                      <p>{selectedTracking?.motorSkillTracking?.note || ""}</p>
                    </div>
                    {/* <div className="image-wraper">
                      <img
                        src={
                          selectedTracking?.motorSkillTracking?.image ||
                          baby_images
                        }
                        alt="Baby wrapped in towel"
                      />
                    </div> */}
                  </div>
                </div>
              </div>
            ) : null}
          </div>


        </div>
      </div>
    </>
  );
};

export default MotorSkillsTracking;
